import persianNumberFormat from "../../../helper/PersianNumberFormat";

export function BarChart(name, count, title) {

  return {
    type: "bar",
    height: 220,
    series: [
      {
        name: name,
        data: count ?? [],
      },
    ],
    options: {
      colors: ["#388e3c"],
      plotOptions: {
        bar: {
          columnWidth: "16%",
          borderRadius: 5,
        },
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: title ?? [],
      },
      yaxis: {
        labels: {
          formatter: (val) => {
            return persianNumberFormat(val, true)
          },
        },
      },
      grid: {
        show: true,
        borderColor: "#dddddd",
        strokeDashArray: 5,
        xaxis: {
          lines: {
            show: false,
          },
        },
        padding: {
          top: 5,
          right: 10,
        },
      },
    },


  }
}

export default BarChart;
